import { Component, OnInit, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import MetisMenu from 'metismenujs';
import { Router, NavigationEnd } from '@angular/router';

import { EventService } from '../../../core/services/event.service';


import { MENU } from './menu';
import { MenuItem } from './menu.model';
import { ToastrService } from 'ngx-toastr';
import { AuthenticationService } from 'src/app/core/services/auth.service';
import { SupportticketComponent } from 'src/app/pages/supportticket/supportticket.component';
import { CountService } from 'src/app/core/services/count.service';
import { SupportComponent } from 'src/app/pages/support/support.component';
import { TicketsComponent } from 'src/app/pages/tickets/tickets.component';
import { TicketviewComponent } from 'src/app/pages/ticketview/ticketview.component';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit, AfterViewInit {
  
  menu: any;
  support:any
  order:any;
  showOverlay = false
  superuser:any;
  portal_name:any;
  portal_id:any;
  portal_account_id:any;
  d2c_name:any
  is_whatsapp:any
  is_whatsapp1:any
  is_whatsapp2:any
  is_whatsapp3:any


  menuItems = [];

  @ViewChild('sideMenu') sideMenu: ElementRef;
  @ViewChild(SupportComponent) SupportComponent!: SupportComponent;  
  @ViewChild(TicketsComponent)  TicketsComponent!: TicketsComponent;  
  // @ViewChild(TicketviewComponent)  TicketviewComponent!: TicketviewComponent;  
  // @ViewChild(SupportticketComponent) SupportticketComponent!: SupportticketComponent;  



  constructor(
    private eventService: EventService, 
    private router: Router,   
    private toastr: ToastrService,
    public countservice :CountService,
    

    private authService: AuthenticationService,) {
    router.events.forEach((event) => {
      if (event instanceof NavigationEnd) {
        this._activateMenuDropdown();
      }
    });
  }

  ngOnInit(): void {
    this.superuser = localStorage.getItem('is_superuser')
    this.initialize();

    this.unread_ticket();
    this.countservice.unread_ticket();
    console.log('order_count',this.countservice.order)

 


  }

  ngAfterViewInit() {
    this.menu = new MetisMenu(this.sideMenu.nativeElement);

    this._activateMenuDropdown();
  }

  /**
   * remove active and mm-active class
   */
  _removeAllClass(className) {
    const els = document.getElementsByClassName(className);
    while (els[0]) {
      els[0].classList.remove(className);
    }
  }

  /**
   * Activate the parent dropdown
   */
  _activateMenuDropdown() {
    this._removeAllClass('mm-active');
    this._removeAllClass('mm-show');
    const links = document.getElementsByClassName('side-nav-link-ref');
    let menuItemEl = null;

    const paths = [];
    // tslint:disable-next-line: prefer-for-of
    for (let i = 0; i < links.length; i++) {
      // tslint:disable-next-line: no-string-literal
      paths.push(links[i]['pathname']);
    }
    const itemIndex = paths.indexOf(window.location.pathname);
    if (itemIndex === -1) {
      const strIndex = window.location.pathname.lastIndexOf('/');
      const item = window.location.pathname.substr(0, strIndex).toString();
      menuItemEl = links[paths.indexOf(item)];
    } else {
      menuItemEl = links[itemIndex];
    }

    if (menuItemEl) {
      menuItemEl.classList.add('active');
      const parentEl = menuItemEl.parentElement;

      if (parentEl) {
        parentEl.classList.add('mm-active');

        const parent2El = parentEl.parentElement.closest('ul');
        if (parent2El && parent2El.id !== 'side-menu') {
          parent2El.classList.add('mm-show');
          const parent3El = parent2El.parentElement;

          if (parent3El && parent3El.id !== 'side-menu') {
            parent3El.classList.add('mm-active');
            const childAnchor = parent3El.querySelector('.has-arrow');
            const childDropdown = parent3El.querySelector('.has-dropdown');

            if (childAnchor) { childAnchor.classList.add('mm-active'); }
            if (childDropdown) { childDropdown.classList.add('mm-active'); }

            const parent4El = parent3El.parentElement;
            if (parent4El && parent4El.id !== 'side-menu') {
              parent4El.classList.add('mm-show');
              const parent5El = parent4El.parentElement;
              if (parent5El && parent5El.id !== 'side-menu') {
                parent5El.classList.add('mm-active');
                const childanchor = parent5El.querySelector('.is-parent');
                if (childanchor && parent5El.id !== 'side-menu') { childanchor.classList.add('mm-active'); }
              }
            }
          }
        }
      }
    }
  }

  /**
   * Initialize
   */
  initialize(): void {
    this.menuItems = MENU;
  }

  /**
   * Returns true or false if given menu item has child or not
   * @param item menuItem
   */
  hasItems(item: MenuItem) {
    return item.subItems !== undefined ? item.subItems.length > 0 : false;
  }

  /**
   * Change the layout onclick
   * @param layout Change the layout
   */
  changeLayout(layout: string) {
    this.eventService.broadcast('changeLayout', layout);
  }

  /**
   * Light sidebar
   */
  lightSidebar() {
    document.body.setAttribute('data-sidebar', 'light');
    document.body.setAttribute('data-topbar', 'dark');
    document.body.removeAttribute('data-sidebar-size');
    document.body.removeAttribute('data-layout-size');
    document.body.removeAttribute('data-keep-enlarged');
    document.body.classList.remove('vertical-collpsed');
  }

  /**
   * Compact sidebar
   */
  compactSidebar() {
    document.body.setAttribute('data-sidebar-size', 'small');
    document.body.setAttribute('data-sidebar', 'dark');
    document.body.removeAttribute('data-topbar');
    document.body.removeAttribute('data-layout-size');
    document.body.removeAttribute('data-keep-enlarged');
    document.body.classList.remove('sidebar-enable');
    document.body.classList.remove('vertical-collpsed');
  }

  /**
   * Icon sidebar
   */
  iconSidebar() {
    document.body.classList.add('sidebar-enable');
    document.body.classList.add('vertical-collpsed');
    document.body.setAttribute('data-sidebar', 'dark');
    document.body.removeAttribute('data-layout-size');
    document.body.removeAttribute('data-keep-enlarged');
    document.body.removeAttribute('data-topbar');
  }

  /**
   * Boxed layout
   */
  boxedLayout() {
    document.body.setAttribute('data-keep-enlarged', 'true');
    document.body.setAttribute('data-layout-size', 'boxed');
    document.body.setAttribute('data-sidebar', 'dark');
    document.body.classList.add('vertical-collpsed');
    document.body.classList.remove('sidebar-enable');
    document.body.removeAttribute('data-topbar');
  }

  /**
   * Colored sidebar
   */
  coloredSidebar() {
    document.body.setAttribute('data-sidebar', 'colored');
    document.body.removeAttribute('data-sidebar-size');
    document.body.removeAttribute('data-layout-size');
    document.body.classList.remove('vertical-collpsed');
    document.body.removeAttribute('data-topbar');
  }

  unread_ticket() {
    this.superuser = localStorage.getItem('is_superuser')

    if (this.superuser == 'true') {
      this.portal_name = localStorage.getItem('portal_name2')
      this.portal_id = localStorage.getItem('portal_id2')
      this.portal_account_id = localStorage.getItem('portal_account_id2')
      this.d2c_name = localStorage.getItem('d2c_name2')

    }
    else {
      this.portal_name = localStorage.getItem('portal_name')
      this.portal_id = localStorage.getItem('portal_id')
      this.portal_account_id = localStorage.getItem('portal_account_id')
      this.d2c_name = localStorage.getItem('d2c_name')
    }
    let data ={
      'portal_id':this.portal_id,
      'portal_account_id':this.portal_account_id
    }
    this.showOverlay=true;
    this.authService.unread_tickets(data).subscribe((res: any) => {
      let mes = JSON.parse(res);
      res = mes
      if(mes.statusCode === 200){
        console.log(mes)
        this.is_whatsapp = localStorage.getItem('is_whatsapp')
        this.is_whatsapp1 = localStorage.getItem('is_whatsapp_marketing')
        this.is_whatsapp2 = localStorage.getItem('order_notifications')
        this.is_whatsapp3 = localStorage.getItem('custom_notifications')
        console.log(this.is_whatsapp,this.is_whatsapp1,this.is_whatsapp2,this.is_whatsapp3)
        console.log(localStorage.getItem('is_whatsapp'),localStorage.getItem('is_whatsapp_marketing'),localStorage.getItem('order_notifications'),localStorage.getItem('custom_notifications'))
        this.order = mes.order_ticket_count
        this.support = mes.support_ticket_count
        localStorage.setItem('ticketss', JSON.stringify(mes.order_ticket)); 
        localStorage.setItem('ticketss1', JSON.stringify(mes.support_ticket))

        // localStorage.setItem('order',mes.order_ticket_count)
        // localStorage.setItem('support',mes.support_ticket_count)
  
  
      }
      else{
        this.toastr.error(res.error, 'Error')
        this.showOverlay=false
        // this.modalService.dismissAll('Close click');
  
  
  
  
      }
    })
      // .catch(error => {
        //   this.error = error ? error : '';
        // });
    
  }

}
